import { types as t } from 'mobx-state-tree';
import { AbstractQuestion } from '../abstract-question.store';
import { CorrectAnswer } from '../CorrectOption/_extends/correct-answer.store';
import { BlankItem } from '../Blank/blank-item.store';
import { BlankUserAnswer } from '../Blank/blank-user-answer.store';
import { KeyValueModel } from '../../key-value.store';
import { Paragraph } from '../../../test-section/models/Question/_extends/admin-abstract-q-with-paragraph.store';

export const CompletionWithHintBlankUserAnswer = t.compose(
  t.model({
    userAnswerKey: t.maybeNull(t.number),
  }),
  BlankUserAnswer,
);

export const CompletionWithHintAnswerQuestion = AbstractQuestion.named(
  'CompletionWithHintAnswerQuestion',
).props({
  blanks: t.maybeNull(t.array(BlankItem)),
  correctAnswers: t.maybeNull(t.array(CorrectAnswer)),
  heading: t.maybeNull<any>(t.string),
  paragraph: t.maybeNull(Paragraph),
  userAnswers: t.optional(t.array(CompletionWithHintBlankUserAnswer), []),
  options: t.array(KeyValueModel),
});

